/* Dansk katalog for locale-no.js (del 9 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'sub.noInvoiceSentText': 'Fakturaer, du sender fra dette abonnement, vises her.',
  'sub.invoiceRunFallback': 'Fakturakørsel',
  'sub.statusSaved': 'gemt',
  'sub.noEmailSentText': 'E-mails, du sender til kunderne, vises her.',
  'sub.emailLogFallback': 'E-maillog',
  'sub.recipientsCount': '{count} modtagere',
  'sub.changesSaved': 'Ændringer gemt',
  'sub.listCreated': 'Liste oprettet',
  'sub.subscriptionCreated': 'Abonnement oprettet',
  'sub.saveError': 'Kunne ikke gemmes.',
  'sub.customersSaved': 'Kunder gemt',
  'sub.saveCustomersError': 'Kunderne kunne ikke gemmes.',
  'sub.agreementResumed': 'Aftalen er aktiv igen',
  'sub.agreementPaused': 'Aftalen er sat på pause',
  'sub.updateAgreementError': 'Aftalen kunne ikke opdateres.',
  'sub.listDeleted': 'Listen blev slettet',
  'sub.subscriptionDeleted': 'Abonnementet blev slettet',
  'sub.deleteError': 'Kunne ikke slettes.',
  'sub.emailsSentToast': '{count} e-mails sendt',
  'sub.emailsSentFailedSuffix': ', {count} ikke sendt',
  'sub.sendEmailError': 'E-mailen kunne ikke sendes.',
  'sub.searchSubPlaceholder': 'Søg efter abonnement, kunde eller beløb...',
  'sub.searchListPlaceholder': 'Søg efter liste eller kunde...',
  'sub.emptySubTitle': 'Ingen abonnementer endnu',
  'sub.emptyListTitle': 'Ingen lister endnu',
  'sub.emptySubText': 'Opret dit første abonnement for at fakturere kunder løbende.',
  'sub.emptyListText': 'Opret din første kundeliste.',
  'sub.preservedSubscriptionsNotice': '{count} ældre kundeabonnementer er bevaret i app-state og kan migreres senere.',
  'agreements.customer': 'Kunde',
  'agreements.tab.subscriptions': 'Abonnementer',
  'agreements.tab.recurring': 'Tilbagevendende',
  'agreements.tab.lists': 'Lister',
  'agreements.unknownCustomer': 'Ukendt kunde',
  'agreements.recurringInvoice': 'Tilbagevendende faktura',
  'agreements.lastSent': 'Sidst sendt',
  'agreements.nextDelivery': 'Næste udsendelse',
  'agreements.net': 'Netto',
  'agreements.amount': 'Beløb',
  'agreements.total': 'I alt',
  'agreements.status': 'Status',
  'agreements.status.active': 'Aktiv',
  'agreements.status.paused': 'På pause',
  'agreements.status.ended': 'Afsluttet',
  'agreements.status.failed': 'Mislykket',
  'agreements.pause': 'Pause',
  'agreements.resume': 'Genoptag',
  'agreements.interval': 'Interval',
  'agreements.interval.weekly': 'Ugentligt',
  'agreements.interval.fourteen_days': 'Hver 14. dag',
  'agreements.interval.monthly': 'Månedligt',
  'agreements.interval.quarterly': 'Kvartalsvis',
  'agreements.interval.semiannual': 'Halvårligt',
  'agreements.interval.annual': 'Årligt',
  'agreements.paymentTerms': 'Betalingsfrist',
  'agreements.days': '{count} dage',
  'agreements.units': 'stk.',
  'agreements.invoiceLine': 'Fakturalinje',
  'agreements.deliveries': 'Udsendelser',
  'agreements.noDeliveries': 'Ingen automatiske udsendelser endnu.',
  'agreements.invoice': 'Faktura',
  'agreements.sent': 'Sendt',
  'agreements.processing': 'Behandles',
  'agreements.emptyTitle': 'Ingen tilbagevendende fakturaer',
  'agreements.emptyText': 'Slå Tilbagevendende til, når du opretter en faktura. Serien vises her og kan sættes på pause når som helst.',
  'agreements.autoSend': 'Automatisk udsendelse',
  'agreements.autoSendHelp': 'Plumme opretter og sender fakturaen på næste fakturadato. Kan sættes på pause fra Aftaler.',
  'agreements.newRecurring': 'Ny tilbagevendende',
  'agreements.newRecurringTitle': 'Ny tilbagevendende faktura',
  'agreements.searchRecurring': 'Søg efter kunde, aftale eller beløb...',
  'agreements.sortBy': 'Sortér efter {column}',
  'rep.help': 'Hjælp',
  'rep.excel': 'Excel',
  'rep.allAccountsSub': 'Alle konti i kontoplanen for den valgte periode.',
  'rep.openingChangeClosing': 'Primo / Bevægelse / Ultimo',
  'rep.balanceModeHelp': 'Vælg, hvilken saldo der vises. Primo er saldoen ved periodens start, Bevægelse er bevægelsen i perioden, og Ultimo er saldoen ved slutningen. Ultimo = primo + bevægelse.',
  'rep.groupsHelp': 'Kontiene er inddelt i grupper efter første ciffer: aktiver (1xxx), egenkapital og gæld (2xxx), indtægter (3xxx) og omkostninger (4xxx–7xxx). Tryk for at skjule eller vise gruppen.',
  'rep.displayHelp': 'Vis konto slår kontonummeret til eller fra foran hver linje. Vis som vælger, om beløbene vises i kroner og øre, hele kroner eller hele tusinder.',
  'rep.showAccount': 'Vis konto',
  'rep.showAs': 'Vis som',
  'rep.operatingIncomeHelp': 'Summen af det, virksomheden har tjent på den ordinære drift i den valgte periode.',
  'rep.operatingCostHelp': 'Summen af omkostningerne ved at drive virksomheden i den valgte periode.',
  'rep.resultHelp': 'Driftsindtægter minus driftsomkostninger og finansielle poster. Et positivt tal er overskud, et negativt er underskud.',
  'rep.groupHelp': 'En hovedgruppe i resultatopgørelsen. Tryk for at åbne eller lukke gruppen og se kontiene bag summen.',
  'rep.noLedgerLines': 'Ingen hovedbogslinjer tilgængelige fra backend.',
  'bwf.fixPostedEntry': 'Korrigér postering',
  'bwf.createsDiscrepancy': 'Skaber afvigelse',
  'bwf.entry': 'Postering',
  'bwf.whatToDo': 'Hvad vil du gøre?',
  'bwf.correctPostedAmount': 'Korrekt bogført beløb',
  'bwf.correctDate': 'Korrekt dato',
  'bwf.postedEntry': 'Bogført post',
  'bwf.matched': 'Matchet',
  'bwf.plummaLinks': 'SuperPlumma kobler',
  'bwf.searchInbox': 'Søg på bilag eller beløb…',
  'bwf.clickForPreview': 'Klik for forhåndsvisning, eller træk bilaget til en banklinje',
  'bwf.tapToPick': 'Tryk for at vælge bilaget, og tryk derefter på banklinjen',
  'bwf.tapHint': 'Tryk på et bilag · vælg derefter den banklinje, det hører til',
  'bwf.pickedVoucher': 'Valgt bilag',
  'bwf.pickTapLine': 'Tryk på den banklinje, bilaget hører til.',
  'bwf.cancelPick': 'Annuller',
  'bwf.pickChooseLine': 'Vælg den banklinje, bilaget hører til',
  'bwf.possibleMatch': 'Muligt match',
  'bwf.previewVoucher': 'Forhåndsvis bilag',
  'bwf.annulEntry': 'Annuller posteringen',
  'bwf.correctEntry': 'Korrigér postering',
  'bwf.account': 'Konto',
  'bwf.missing': 'mangler',
  'bwf.searchAccount': 'Søg konto …',
  'bwf.noAccountHits': 'Ingen resultater',
  'bwf.selectedLines': 'linjer valgt',
  'bwf.selectedLinesHelp': 'Vælg, hvad der skal ske med de valgte linjer.',
  'bwf.clearSelection': 'Ryd valg',
  'bwf.bulkProcessing': 'Behandler linje {{index}} af {{total}}',
  'bwf.andNext': 'og næste',
  'bwf.andLast': 'sidste',
  'bwf.openInbox': 'Åbn indbakken',
  'bwf.drawerHint': 'Tryk på et bilag og derefter på banklinjen — eller træk det ud på linjen.',
  'bwf.selectLine': 'Vælg banklinje',
  'bwf.selectLineHelp': 'Markér banklinjer for at behandle flere på én gang. Skift-klik markerer et interval. Farven viser stadig linjens status.',
  'onb.getStartedTitle': 'Kom i gang med Plumme',
  'onb.getStarted': 'Kom i gang',
  'onb.whatCreate': 'Hvad vil du oprette?',
  'onb.whatCreateHelp': 'Vælg, hvad du vil opsætte nu. Du kan altid tilføje mere senere.',
  'onb.registerCompany': 'Registrér et selskab til fakturering, bogføring og moms.',
  'onb.backendComing': 'En separat backend-model er nødvendig, før dette kan aktiveres.',
  'onb.createPersonal': 'Opret din privatøkonomi',
  'onb.createPersonalHelp': 'Dette opretter en separat privatøkonomibruger, som du finder via Min side og brugervælgeren.',
  'onb.welcome': 'Velkommen',
  'onb.letsSetUp': 'Lad os opsætte din virksomhed',
  'onb.tellUsAbout': 'Fortæl os om virksomheden',
  'onb.signedIn': 'Logget ind',
  'onb.sweden': 'Sverige',
  'onb.denmark': 'Danmark',
  'onb.companyNamePh': 'F.eks. Joda Consulting AS',
  'onb.nineDigits': '9 cifre',
  'onb.resetAndSearch': 'Nulstil og søg igen',
  'onb.checkingExisting': 'Tjekker, om virksomheden allerede findes i Plumme...',
  'onb.searchingRegistry': 'Søger i Brønnøysundregistrene...',
  'onb.companyForm': 'Virksomhedsform',
  'onb.searchingAddress': 'Søger efter adresse...',
  'onb.oslo': 'Oslo',
  'onb.whichPages': 'Hvilke sider vil du bruge?',
  'onb.menuNotLoaded': 'Sidemenuen er ikke indlæst endnu. Alle standardsider bliver synlige.',
  'onb.bankLater': 'Bankforbindelse kommer senere',
  'onb.connectWith': 'Forbind med',
  'onb.noBankData': 'Bankforbindelse er endnu ikke aktiv. Du kan uploade kontoudtog manuelt, når du ønsker det.',
  'onb.allSet': 'Alt klar',
  'onb.allSetHelp': 'Virksomheden er oprettet i backend, tilføjet til dine virksomheder og valgt som aktiv virksomhed.',
  'onb.goToPlumme': 'Gå til Plumme',
  'air.sub': 'Se, sammenlign, udskriv og download måneds- og årsrapporter for virksomheden',
  'air.help': 'Her laver du måneds- og årsrapporter for virksomheden. Vælg periode og eventuelt et år at sammenligne med, så opdateres nøgletallene, grafen og omkostningstabellen automatisk. Du kan udskrive rapporten eller downloade den som PDF.',
  'air.downloadPdf': 'Download PDF',
  'air.chooseWhatToShow': 'Vælg, hvad rapporten skal vise',
  'air.chooseHelp': '»Visning« skifter mellem én måned og hele året. »År« vælger, hvilket år du ser på. »Sammenlign med« lægger et tidligere år ved siden af, så alle tal også viser ændringen i forhold til samme periode det år.',
  'air.keyFigures': 'Nøgletal for perioden',
  'air.keyFiguresHelp': 'De fire vigtigste tal for den valgte periode: indtægter, omkostninger, resultat (indtægter minus omkostninger) og resultatmargin (resultat i procent af indtægterne). Er sammenligning slået til, viser pilen og teksten under hvert tal ændringen i forhold til året før.',
  'air.profitMargin': 'Resultatmargin',
  'air.chartHelp': 'Søjlediagrammet viser indtægter (grøn) og omkostninger (lilla) for hver måned i året, så du hurtigt kan se sæsonudsving og måneder, hvor omkostningerne nærmer sig indtægterne. I månedsvisning fremhæves den måned, du har valgt.',
  'air.costsByCategory': 'Omkostninger fordelt på kategori',
  'air.costsByCategoryHelp': 'Tabellen opdeler de samlede omkostninger på kategori — løn, husleje, markedsføring og så videre. Er sammenligning slået til, ser du sidste års tal og ændringen i procent, hvor rød betyder højere omkostninger og grøn betyder lavere.',
  'air.costCategory': 'Omkostningskategori',
  'pdf.cannotShow': 'Kan ikke vise PDF her',
  'pdf.browserBlocked': 'Browseren blokerede visningen.',
  'pdf.rotate': 'Rotér',
  'tf.subsistenceQuestion': 'Skal der beregnes diæter for denne rejse?',
  'tf.accommodationQuestion': 'Havde du overnatning på denne rejse?',
  'tf.pickEmployee': 'Vælg medarbejder',
  'tf.timeFrom': 'Tidspunkt fra',
  'tf.timeTo': 'Tidspunkt til',
  'tf.mealsCovered': 'Hvilke måltider blev betalt af andre?',
  'hh.household': 'Husstand',
  'hh.help': 'Forbind to separate Privatøkonomi-konti. Egne konti og transaktioner forbliver private; kun oplysninger, der gemmes under Familie, deles.',
  'hh.privacyNote': 'Private konti, transaktioner, skat og personlige planer deles ikke automatisk.',
  'hh.partnerEmail': 'Partnerens e-mail',
  'hh.partnerEmailPh': 'partner@eksempel.dk',
  'hh.invitesForYou': 'Invitationer til dig',
  'hh.wantsToLink': 'Vil forbinde Privatøkonomi-kontiene som en husstand',
  'hh.decline': 'Afvis',
  'hh.accept': 'Acceptér',
  'hh.pendingInvites': 'Ventende invitationer',
  'hh.awaitingReply': 'Venter på svar',
  'srch.placeholder': 'Søg i kunder, fakturaer, produkter, bilag, projekter …',
  'srch.esc': 'esc',
  'srch.recent': 'Seneste søgninger',
  'srch.noMatches': 'Ingen resultater for »{query}«.',
  'srch.tryPageName': 'Prøv et navn, nummer, beløb, sidenavn eller hjælpeemne.',
  'srch.group.customers': 'Kunder',
  'srch.group.suppliers': 'Leverandører',
  'srch.group.products': 'Produkter',
  'srch.group.sales': 'Salg og fakturaer',
  'srch.group.vouchers': 'Køb og bilag',
  'srch.group.documents': 'Dokumenter og indbakke',
  'srch.group.projects': 'Projekter og timer',
  'srch.group.other': 'Andet i regnskabet',
  'srch.tag.customer': 'Kunde',
  'srch.tag.supplier': 'Leverandør',
  'srch.tag.product': 'Produkt',
  'srch.tag.invoice': 'Salgsdokument',
  'srch.tag.expense': 'Køb',
  'srch.tag.other-sale': 'Andet salg',
  'srch.tag.receipt': 'Indbakke',
  'srch.tag.project': 'Projekt',
  'srch.tag.activity': 'Aktivitet',
  'srch.tag.mileage': 'Kørebog',
  'srch.tag.agreement': 'Aftale',
  'srch.tag.company-document': 'Dokument',
  'srch.tag.bank-statement': 'Kontoudtog',
  'srch.recentDefaults': 'faktura|løn|moms',
  'srch.group.shortcuts': 'Genveje',
  'srch.nav.sub': 'Side i Plumme',
  'srch.help.sub': 'Hjælpeartikel',
  'srch.hint.browse': 'gennemse',
  'srch.hint.open': 'åbn',
  'srch.hint.close': 'luk',
  'srch.countShown': '{count} resultater vist',
  'srch.fallback.trip': 'Køretur',
  'srch.kind.offer': 'Tilbud',
  'srch.kind.invoice': 'Faktura',
  'srch.kind.invoiceDraft': 'Fakturakladde',
  'srch.kind.orderConfirmation': 'Ordrebekræftelse',
  'srch.kind.sale': 'Salg',
  'srch.kind.customerList': 'Kundeliste',
  'hlp.explainMode': 'Forklar mig – tryk, og tryk derefter på det, du er i tvivl om (genvej: ? eller Ctrl+I)',
  'hlp.helpModeOn': 'Hjælpetilstand er slået til.',
  'hlp.tapWhatever': 'Tryk på det, du er i tvivl om, så forklarer vi det.',
  'hlp.shortcutHint': 'Tryk ? eller Ctrl+I for at slå til/fra.',
  'hlp.exit': 'Afslut',
  'sd.deleteAllCustomers': 'Slet alle kunder',
  'sd.deleteAllSuppliers': 'Slet alle leverandører',
  'sd.deleteAllProducts': 'Slet alle produkter',
  'sd.exportLedger': 'Eksportér hovedbog',
  'sd.importLedger': 'Importér hovedbog',
  'sd.exportDetails': 'Eksportér detaljer',
  'sd.importDetails': 'Importér detaljer',
  'sd.exportVouchers': 'Eksportér bilag',
  'sd.importVouchers': 'Importér bilag',
  'sd.deleteBusinessHelp': 'Slet virksomhed fjerner den valgte virksomhed efter 30 dage via backend. Det er en alvorlig handling.',
  'sd.permissionsHelp': 'Kun ejer eller admin kan nulstille data og tømme registre. Kun ejeren kan slette virksomheden.',
  'ha.h6.title': 'Sådan indsender du MVA-meldingen',
  'ha.cat.vat': 'Moms og afgifter',
  'ha.read3': '3 min. læsning',
  'ha.h6.lead': 'MVA-meldingen viser, hvor meget moms virksomheden har opkrævet på salg og betalt på køb i en periode. Plumme beregner tallene automatisk ud fra bogførte bilag — du kontrollerer dem og indsender angivelsen hos Skatteetaten. Sådan gør du.',
  'ha.h6.before': 'Før du begynder',
  'ha.h6.beforeText': 'Sørg for, at alle køb og salg i perioden er bogført, og at indbakken er tom. Tallene i angivelsen hentes direkte fra regnskabet, så det, der ikke er bogført, kommer heller ikke med i angivelsen.',
  'ha.h6.reminded': 'Du får besked i god tid',
  'ha.h6.remindedText': 'Plumme minder dig automatisk om fristen. Du finder altid den næste frist på forsiden og under Indsendelser.',
  'ha.h6.openPeriod': 'Åbn den rigtige periode',
  'ha.h6.openPeriodText': 'Gå til Indsendelser → MVA-melding. De perioder, der kræver handling, ligger øverst. Tryk på »Åbn angivelse« for den periode, du skal indsende.',
  'ha.h6.fig1': 'Periodeoversigten. »3. termin 2026« kræver handling og har frist 31. august.',
  'ha.h6.check': 'Kontrollér beregningen',
  'ha.h6.checkText': 'Øverst ser du udgående moms (det, du har opkrævet på salg) minus indgående moms (det, du har betalt på køb). Forskellen er enten at betale eller til gode. I dette eksempel er 49 834 kr til gode.',
  'ha.h6.fig2': 'Udgående minus indgående moms giver det beløb, du skal betale eller få tilbage.',
  'ha.h6.codes': 'Gennemgå kodeoversigten',
  'ha.h6.codesText': 'Kodeoversigten viser, hvordan grundlaget fordeler sig på de forskellige momskoder — salg, køb og import. Tryk på en kode for at se, hvilke bilag der ligger bag tallet. Stemmer alt, trykker du på »Kontrollér tallene«.',
  'ha.h6.fig3': 'Hver linje viser grundlag, sats og moms pr. kode. Tryk på en kode for at se bilagene bag.',
  'ha.h6.deviation': 'Tjek afvigelser, før du sender',
  'ha.h6.deviationText': 'Får du et beløb, du ikke kan genkende, bør du gennemgå bogføringen før indsendelse. Det er nemmere at rette op, før angivelsen er sendt, end bagefter.',
  'ha.h6.send': 'Indsend angivelsen hos Skatteetaten',
  'ha.h6.sendText': 'Plumme kan ikke sende MVA-meldingen til Skatteetaten. Indtast tallene fra Plumme, indsend angivelsen i Skatteetatens tjeneste, og gem kvitteringen. Gå så tilbage til perioden i Plumme, og tryk på »Markér som indsendt uden for Plumme«. Angiv datoen, du indsendte, og gerne referencen fra kvitteringen. Så låses bilagene i perioden, og perioden tæller som indsendt i årsafslutningen.',
  'ha.h6.after': 'Efter indsendelse',
  'ha.h6.afterText': 'Skal du betale, finder du KID og kontonummer på kvitteringen fra Skatteetaten. Når perioden er markeret som indsendt uden for Plumme, og beløbet er betalt eller tilbagebetalt, registrerer du afregningen på perioden med »Registrér betaling« eller »Registrér tilbagebetaling«, så stemmer regnskabet med skattekontoen.',
  'ha.h12.title': 'Sådan laver du en faktura',
  'ha.cat.sales': 'Salg og faktura',
  'ha.h12.lead': 'Med Nyt salg laver du en faktura til en kunde i nogle få trin. Du vælger kunde, udfylder linjerne og ser en levende forhåndsvisning, før du opretter og sender. Salget bogføres automatisk.',
  'ha.h12.beforeText': 'Det er en fordel at have kunden og produkterne gemt i forvejen, men du kan også skrive både modtager og linjer som fritekst undervejs. Alt kan ændres, før du opretter fakturaen.',
  'ha.h12.open': 'Åbn Nyt salg, og vælg faktura',
  'ha.h12.openText': 'Gå til Nyt salg i menuen. Øverst vælger du dokumenttype — vælg »Faktura«. Du kan også lave tilbud eller ordrebekræftelse herfra.',
  'ha.h12.quoteOrder': 'Tilbud og ordrebekræftelse',
  'ha.h12.quoteOrderText': 'Samme fremgangsmåde gælder for tilbud og ordrebekræftelse — vælg blot den rigtige type i »Ny faktura«-menuen øverst, så er trinene og felterne de samme. »Andet salg« er lidt anderledes: Der uploader du et bilag som dokumentation i stedet for at vælge kunde.',
  'ha.h12.customerText': 'I trinnet »Kunde« søger du en gemt kunde, liste eller et abonnement frem — eller tryk på »Ny kunde« for at indtaste en modtager, der ikke er gemt. Navn og adresse hentes automatisk ind i dokumentet.',
  'ha.h12.fig1': 'Trin 1 »Kunde«: søg en gemt kunde, liste eller et abonnement frem — eller opret en ny modtager.',
  'ha.h12.details': 'Udfyld detaljer',
  'ha.h12.detailsText': 'Under »Detaljer« angiver du fakturadato og forfaldsdato samt eventuelle referencer. Vil du have, at fakturaen sendes automatisk hver periode, slår du »Tilbagevendende« til.',
  'ha.h12.fig2': 'Trin 2 »Detaljer«: fakturadato, forfaldsdato og referencer. Slå »Tilbagevendende« til for automatisk udsendelse.',
  'ha.h12.lines': 'Tilføj linjer',
  'ha.h12.linesText': 'I trinnet »Linjer« tilføjer du det, du sælger. Vælg et gemt produkt eller skriv fritekst, og angiv antal, pris og momssats. Linjesummen beregnes automatisk.',
  'ha.h12.fig3': 'Trin 3 »Linjer«: hver linje har antal, pris og momssats. Linjesum og totalsum beregnes for dig.',
  'ha.h12.livePreview': 'Live forhåndsvisning',
  'ha.h12.livePreviewText': 'Ved siden af formularen ser du hele tiden, hvordan det færdige dokument bliver for kunden. Brug »Skift til alt på én side«, hvis du hellere vil se alle felterne på én gang.',
  'ha.h12.preview': 'Forhåndsvis og opret',
  'ha.h12.previewText': 'I »Forhåndsvisning« kontrollerer du afsender, kundeoplysninger, linjer og totalsum. Stemmer alt, opretter du fakturaen — og kan sende den til kunden på e-mail eller downloade den som PDF.',
  'ha.h12.fig4': 'Trin 4 »Forhåndsvisning«: kontrollér dokumentet og totalsummen, før du opretter fakturaen.',
  'ha.h12.afterText': 'Når fakturaen er oprettet, bogføres salget automatisk på den rigtige konto, og du finder den igen i Fakturalisten med status og forfald.',
  'ha.h13.title': 'Registrér andet salg',
  'ha.read2': '2 min. læsning',
  'ha.h13.lead': 'Andet salg er til salg, der ikke kræver en almindelig faktura — som kontantsalg, udtag eller salg foretaget uden for Plumme. Du vælger »Andet salg« i Nyt salg, uploader et bilag som dokumentation, udfylder beløb og moms og vælger, hvor pengene kom ind. Salget bogføres automatisk.',
  'ha.h13.when': 'Hvornår bruger du andet salg?',
  'ha.h13.whenText': 'Brug andet salg, når du ikke skal sende en faktura til en kunde — for eksempel kontantsalg, privat udtag af varer eller et salg, der allerede er foretaget uden for systemet og bare skal bogføres. Skal kunden faktureres, opretter du en faktura i stedet.',
  'ha.h13.choose': 'Vælg Andet salg',
  'ha.h13.chooseText': 'Gå til Nyt salg, og vælg »Andet salg« i dokumenttypemenuen øverst. Flowet får så et selvstændigt »Bilag«-trin først.',
  'ha.h13.receiptText': 'I »Bilag«-trinnet uploader du et billede eller en PDF som dokumentation for salget — for eksempel en kvittering eller et salgsnotat.',
  'ha.h13.details': 'Udfyld detaljer og »Betalt til«',
  'ha.h13.detailsText': 'Under »Detaljer« angiver du dato og vælger »Betalt til« — hvor pengene kom ind: Driftskonto, Kontant eller Privat. Valget styrer, hvilken konto salget bogføres mod (bank, kasse eller privat udtag).',
  'ha.h13.fig1': 'I »Detaljer« vælger du »Betalt til« — Driftskonto, Kontant eller Privat. Det afgør, hvilken konto salget bogføres mod.',
  'ha.h13.linesText': 'I »Linjer« tilføjer du det, du solgte, med antal, pris og momssats. Sum og moms beregnes automatisk.',
  'ha.h13.fig2': 'Tilføj salgslinjer med beløb og momssats. Summen beregnes for dig.',
  'ha.h13.register': 'Registrér salget',
  'ha.h13.registerText': 'Kontrollér opsummeringen, og tryk på »Registrér salg«. Salget bogføres, og bilaget arkiveres under Transaktioner.',
  'ha.h13.invoiceOrOther': 'Faktura eller andet salg?',
  'ha.h13.invoiceOrOtherText': 'Skal du kræve betaling fra en kunde, så opret en faktura (Nyt salg → Faktura). Andet salg er til salg, der allerede er afregnet eller ikke kræver et betalingskrav.',
  'ha.h1.title': 'Opret en gentagende faktura',
  'ha.h1.lead': 'En gentagende faktura sendes automatisk med jævne mellemrum — perfekt til abonnementer og faste ydelser. Du sætter den op én gang, så klarer Plumme resten.',
  'ha.h1.start': 'Start en ny faktura',
  'ha.h1.startText': 'Gå til Nyt salg, og udfyld kunde og fakturalinjer som normalt.',
  'ha.h1.turnOn': 'Slå »Gentagende« til',
  'ha.h1.turnOnText': 'Under Detaljer slår du »Gentagende« til. Vælg, hvor ofte fakturaen skal sendes (hver uge, hver 14. dag, måned, kvartal eller år), og hvornår den forfalder.',
  'ha.h1.fig1': 'Slå »Gentagende« til i Detaljer-trinnet. Så vælger du »Sendes hver« (interval) og »Forfald«.',
  'ha.h1.autoText': 'Plumme opretter og sender automatisk en ny faktura på e-mail hver periode. Under Aftaler → Gentagende ser du, hvornår den næste faktura sendes, og kan sætte den på pause og genoptage den.',
  'ha.h1.control': 'Sæt på pause i tide',
  'ha.h1.controlText': 'Fakturaen sendes uden forudgående varsel. Har noget ændret sig, sætter du den på pause under Aftaler → Gentagende før fakturadatoen. Kunden skal have en e-mailadresse, ellers sendes der ingen faktura.',
  'ha.h2.title': 'Betalingen stemmer ikke med fakturaen',
  'ha.h2.lead': 'Når et indbetalt beløb afviger fra fakturabeløbet, registrerer du det beløb, der faktisk er kommet ind — så holder Plumme styr på, hvad der mangler.',
  'ha.h2.open': 'Åbn fakturaen',
  'ha.h2.openText': 'Find fakturaen i Fakturalisten, og åbn den. Under »Betalingsstatus« ser du, om den er betalt, delvist betalt eller ikke betalt.',
  'ha.h2.fig1': '»Betalingsstatus« på fakturaen: hvad der er betalt, hvad der mangler, og knappen »Registrér betaling«.',
  'ha.h2.registerText': 'Tryk på »Registrér betaling«, og indtast det beløb, der er kommet ind. Er beløbet mindre end fakturaen, bliver den stående som »Delvist betalt«, og det resterende beløb vises.',
  'ha.h2.fig2': 'I »Registrér betaling« indtaster du det beløb, der er kommet ind. Det resterende vises, og »Afregnet uden betaling« lukker resten uden indbetaling.',
  'ha.h2.handle': 'Håndtér det resterende',
  'ha.h2.handleText': 'Kommer resten senere, registrerer du en ny betaling til den tid. Skal du afslutte fakturaen, uden at resten betales, vælger du »Afregnet uden betaling«. En registreret betaling kan tilbageføres, og hele betalingen kan nulstilles, hvis du har bogført forkert.',
  'ha.h2.autoStatus': 'Status beregnes automatisk',
  'ha.h2.autoStatusText': 'Betalt / delvist betalt / ikke betalt beregnes ud fra de registrerede betalinger mod fakturabeløbet — du behøver ikke selv at angive status.',
  'ha.cat.payroll': 'Løn og medarbejdere',
  'ha.cat.purchase': 'Køb og bilag',
  'ha.cat.bank': 'Bank og betaling',
  'ha.cat.assets': 'Aktiver',
  'ha.cat.budget': 'Budget',
  'ha.cat.closing': 'Årsafslutning',
  'ha.h9.title': 'Registrer et aktiv og en afskrivning',
  'ha.h9.lead': 'Større ting, som virksomheden køber og bruger over flere år — som en pc, et køretøj eller maskiner — føres som aktiver (anlægsaktiver). I stedet for at blive udgiftsført med det samme afskrives de lidt hvert år. Plumme holder styr på afskrivningen for dig.',
  'ha.h9.whenAsset': 'Hvornår er noget et aktiv?',
  'ha.h9.whenAssetText': 'Et køb skal normalt afskrives, når et driftsmiddel har en anskaffelsessum på mindst 30 000 kr og en forventet brugstid på mindst tre år. Grænsen vurderes pr. driftsmiddel, ikke ud fra fakturabeløbet alene.',
  'ha.h9.limit': '30 000-grænsen',
  'ha.h9.limitText': 'Koster det enkelte driftsmiddel under 30 000 kr, kan anskaffelsessummen normalt udgiftsføres direkte samme år. Fysisk eller funktionelt integrerede dele kan skulle vurderes samlet.',
  'ha.h9.register': 'Registrer aktivet',
  'ha.h9.registerText': 'Gå til Køb → Aktiver, og tryk på «Nyt aktiv» — eller registrer det direkte fra købet. Giv det et navn, og angiv anskaffelsessum og anskaffelsesdato.',
  'ha.h9.group': 'Vælg saldogruppe',
  'ha.h9.groupText': 'Vælg, hvilken gruppe aktivet hører til (f.eks. gruppe a for it-udstyr, c for varevogne, d for maskiner og inventar). Gruppen bestemmer afskrivningssatsen.',
  'ha.h9.depreciate': 'Lad Plumme afskrive',
  'ha.h9.depreciateText': 'Hvert år beregnes afskrivningen automatisk som en fast procentdel af den resterende værdi (saldometoden). Du ser bogført værdi og samlet afskrivning i aktivregisteret.',
  'ha.h9.sell': 'Når du sælger eller skiller dig af med aktivet',
  'ha.h9.sellText': 'Sælger du aktivet, registrerer du salgssummen på det. Gevinst eller tab i forhold til bogført værdi håndteres automatisk — eventuelt via en gevinst- og tabskonto, der fordeler beløbet over flere år.',
  'ha.h10.title': 'Lav et budget for året',
  'ha.h10.lead': 'Et budget er en plan for dine indtægter og omkostninger gennem året. Når du har indtastet det, sammenligner Plumme løbende budgettet med de faktiske tal, så du kan se, om du ligger som planlagt.',
  'ha.h10.method': 'Vælg metode',
  'ha.h10.methodText': 'Gå til Budget, og vælg, hvordan du vil starte: Med «Manuelt» indtaster du alt selv, med «Forslag» svarer du på nogle enkle spørgsmål, og med «AI-forslag» beskriver du virksomheden med dine egne ord, så laver Plumme et udkast.',
  'ha.h10.amounts': 'Indtast indtægter og omkostninger',
  'ha.h10.amountsText': 'Under «Budget pr. kategori» tilføjer du en indtægts- eller omkostningskategori med et årsbeløb. Beløbet fordeles på måneder, som du kan justere, hvis aktiviteten varierer gennem året.',
  'ha.h10.variance': 'Følg op på afvigelser',
  'ha.h10.varianceText': 'I «Analyse» og «Oversigt» ser du budget mod faktisk resultat, måned for måned. Afvigelsen viser, om du ligger over eller under planen, og hvilken konto der afviger mest.',
  'ha.h10.startSimple': 'Start enkelt',
  'ha.h10.startSimpleText': 'Du behøver ikke budgettere alt. Begynd med de største indtægter og omkostninger — du kan altid tilføje flere kategorier senere.',
  'ha.h11.title': 'Afslut regnskabsåret',
  'ha.h11.lead': 'Årsafslutningen lukker regnskabsåret. Du kontrollerer, at alt er bogført korrekt, låser året og forbereder derefter skattemelding og årsregnskab. Plumme guider dig gennem hvert trin.',
  'ha.h11.before': 'Før du afslutter',
  'ha.h11.beforeText': 'Sørg for, at alle bilag er bogført, at indbakken er tom, og at momsperioderne er indberettet. Jo mere der er på plads, jo glattere går afslutningen.',
  'ha.h11.checklist': 'Gennemgå tjeklisten',
  'ha.h11.checklistText': 'Vælg «Gennemgå tjeklisten». Plumme tjekker punkter som bankafstemning, moms, løn og aktiver. Punkter, der kræver handling, skal løses, før året kan lukkes.',
  'ha.h11.closeYear': 'Afslut året',
  'ha.h11.closeYearText': 'Når alt er kontrolleret, afslutter du regnskabsåret. Året låses for ændringer — men du kan altid genåbne det, hvis noget skal rettes.',
  'ha.h11.taxReturn': 'Forbered skattemeldingen',
  'ha.h11.taxReturnText': 'Plumme laver et udkast til skattemeldingen ud fra regnskabet. Gennemgå udkastet, og kontroller tallene. Selve skattemeldingen indsender du hos Skatteetaten, uden for Plumme, og markerer den som indsendt her.',
  'ha.h11.annualAccounts': 'Udarbejd årsregnskabet',
  'ha.h11.annualAccountsText': 'Til sidst opstilles årsregnskabet ud fra tallene, og dokumenterne underskrives. Årsregnskabet indsender du til Regnskapsregisteret i Altinn, uden for Plumme (gælder regnskabspligtige).',
  'ha.h11.reconciled': 'Bankafstemte perioder',
  'ha.h11.reconciledText': 'Bilag i en bankafstemt periode kan ikke ændres uden at genåbne perioden. Det sikrer, at afstemningen forbliver korrekt.',
  'ha.h1.save': 'Gem',
  'ha.h2.register': 'Registrer betaling',
  'ha.h12.customer': 'Vælg kunde',
  'ha.h13.receipt': 'Upload bilag',
  'ha.eyebrow': 'Hjælp · {category}',
  'ha.readOn': 'Hjælp · læs videre',
  'ha.backToSearch': 'Tilbage til søgning',
  'ha.goTo': 'Gå til {page}',
  'ha.openedInBackground': 'Åbnede {page} i baggrunden',
  'ha.reopen': 'Åbn hjælpeartiklen igen',
  'ha.closeArticle': 'Luk hjælpeartikel',
  'ha.expandImage': 'Åbn billedet i fuld størrelse',
  'ha.collapseImage': 'Minimer billedet',
  'ha.minimize': 'Minimer',
  'ha.minimizeHelp': 'Minimer — hent den frem igen senere',
});
